import { useState } from 'react';
import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import useCreativeStore from 'store/creativeStore';

interface RichProductNativeFormValidationProps {
  defaultForm: any;
  values: any;
}

const useRichProductNativeFormValidation = (
  initialState: RichProductNativeFormValidationProps = {
    defaultForm: {},
    values: {},
  },
) => {
  const { values } = initialState;
  const [errors, setErrors] = useState<any>({ basic: {}, products: '' });
  const { actionType } = useCreativeStore();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('素材名稱必填'),
    bannerImageUrl: Yup.string().notRequired(),
    updateImg: Yup.boolean().notRequired(),
    fileSize: Yup.number()
      .max(20)
      .transform((value) => (Number.isNaN(value) ? null : value))
      .test('is-positive', `檔案大小須小於 2MB`, (value) => {
        const { updateImg } = values;
        if (actionType === 'edit' && updateImg === false) {
          return true;
        }
        return value !== undefined && value !== null && value <= 20;
      }),
    fileType: Yup.string().test(
      'is-png',
      `檔案格式不符合，請重新上傳`,
      (value) => {
        const { updateImg } = values;
        if (actionType === 'edit' && updateImg === false) {
          return true;
        }
        return value !== undefined && value !== null && value === 'image/png';
      },
    ),
    typeProperties: Yup.object().shape({
      width: Yup.number()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .test('is-positive', `檔案寬度不符合`, (value) => {
          const { height } = values.typeProperties;
          if (height === 320) {
            return value !== undefined && value !== null && value === 960;
          }
          return false;
        }),
      height: Yup.number()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .test('is-positive', `檔案高度不符合`, (value) => {
          const { width } = values.typeProperties;
          if (width === 960) {
            return value !== undefined && value !== null && value === 320;
          }
          return false;
        }),
      imageUrl: Yup.string().notRequired(),
    }),
  });

  // 即時驗證表單
  const handleValidation = () => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(function () {
        setErrors({});
      })
      .catch(function (err) {
        // console.log('err', err);
        setErrors(yupToFormErrors(err));
        console.log('errors', yupToFormErrors(err));
      });
  };

  return { validationSchema, errors, setErrors, handleValidation };
};

export default useRichProductNativeFormValidation;
